import axios from 'axios'

export default {
  namespaced: true,
  state() {
    return {
      item: null,
      visibility: null,
      loaded: false,
      error: null,
      token: null
    }
  },
  mutations: {
    set_item(state, v) { state.item = v; },
    set_token(state, v) { state.token = v; },
    set_visibility(state, v) { state.visibility = v; },
    set_loaded(state, v) { state.loaded = v; },
    set_error(state, v) { state.error = v; }
  },
  actions: {
    load(context, token) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);

      return axios.get(`/1.0/interviews/${token}`)
        .then(r => {
          context.commit('set_token', token);
          context.commit('set_item', r.data.data[0]);
          context.commit('set_visibility', r.data.data[0].visibility);
          context.commit('set_loaded', false);
        })
        .catch(e => {
          context.commit('set_error', e);
          context.commit('set_loaded', false);
          return Promise.reject(e);
        })
    },
    set_visibility(context, val) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);
      let {interview_token, status} = val;

      return axios.put(`1.0/interviews/${interview_token}/visibilities`, {visibilities: [{is_active: status}]})
        .then(r => {
          context.commit('set_visibility', r.data.data[0]);
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          return Promise.reject(err);
        })
    }
  },
  getters: {
    item: state => state.item,
    visibility: state => state.visibility,
    token: state => state.token,
    loaded: state => state.loaded,
    error: state => state.error
  }
}
